import { all } from 'redux-saga/effects';
import { ktAuthenticationSagas } from './authentication.sagas';
import { searchQuerySagas } from './searchQuery.sagas';
import { employeesSagas } from './employees.sagas';
import { roomsSagas } from './rooms.sagas';
import { schedulingSagas as oldSchedulingSagas } from './scheduling.sagas';
import { menusSagas } from '../pages/Menus/duck/sagas';
import { identitySagas } from './identity.sagas';
import { newMenuSagas } from '../pages/NewMenu/duck/sagas';
import { editMenuSagas } from '../pages/EditMenu/duck/sagas';
import { gallerySagas } from '../pages/Gallery/duck/sagas';
import { roomGallerySagas } from '../pages/RoomGallery/duck/sagas';
import { childGallerySagas } from '../pages/ChildGallery/duck/sagas';
import { adminEntitiesSagas } from '../pages/Admin/Entities/duck/sagas';
import { adminCentersSagas } from '../pages/Admin/Centers/duck/sagas';
import { timeOffRequestSagas } from '../pages/Scheduling/timeOffDucks/sagas';
import { employeeScheduleSagas } from '../pages/Home/MySchedule/duck/sagas';
import { eventSagas } from '../pages/Events/duck/sagas';
import { channelMessageSagas } from '../pages/Messages/ducks/sagas';
import { centerGallerySagas } from '../pages/CenterGallery/duck/sagas';
import { employeeAttendanceSagas } from '../pages/Attendance/Employee/duck/sagas';
import { schedulingSagas } from '../pages/Scheduling/schedulingDucks/sagas';

export default function * ktSaga () {
  yield all([
    ...ktAuthenticationSagas,
    ...searchQuerySagas,
    ...employeesSagas,
    ...roomsSagas,
    ...oldSchedulingSagas,
    ...menusSagas,
    ...identitySagas,
    ...newMenuSagas,
    ...editMenuSagas,
    ...gallerySagas,
    ...roomGallerySagas,
    ...childGallerySagas,
    ...adminEntitiesSagas,
    ...adminCentersSagas,
    ...timeOffRequestSagas,
    ...employeeScheduleSagas,
    ...eventSagas,
    ...channelMessageSagas,
    ...centerGallerySagas,
    ...employeeAttendanceSagas,
    ...schedulingSagas
  ]);
}
